var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: _vm.selection,
          "is-list": "",
          lazy: "",
          load: _vm.load,
          "row-key": "areaCode",
          "reset-data": _vm.resetData,
          "serial-width": "110",
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName:
                              "v-permission:SettingBaseDataRegionIndex_Add",
                            arg: "SettingBaseDataRegionIndex_Add",
                          },
                        ],
                        staticClass: "main-btn",
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.onAdd()
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("SettingBaseDataRegion.newProvincial"))
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "permission",
                                            rawName:
                                              "v-permission:SettingBaseDataRegionIndex_AddChild",
                                            arg: "SettingBaseDataRegionIndex_AddChild",
                                          },
                                        ],
                                        attrs: {
                                          disabled: !scope.row.BJ_HAS_CHILD,
                                          type: "text",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onAdd(scope.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "SettingBaseDataRegion.table.subordinateArea"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "permission",
                                            rawName:
                                              "v-permission:SettingBaseDataRegionIndex_Edit",
                                            arg: "SettingBaseDataRegionIndex_Edit",
                                          },
                                        ],
                                        staticClass: "edit-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onEdit(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("editText")))]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "permission",
                                            rawName:
                                              "v-permission:SettingBaseDataRegionIndex_Delete",
                                            arg: "SettingBaseDataRegionIndex_Delete",
                                          },
                                        ],
                                        staticClass: "delete-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onDelete(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("delText")))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("DataForm", { ref: "DataForm", on: { reFresh: _vm.reFresh } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }